import { FormlyFieldConfig } from "@ngx-formly/core";
import { Injector } from "@angular/core";
import { FieldDefinitionFields } from "../../../../../../sections/medicinalProduct/message/fieldDefinition-fields";
import { FieldDefinitionConditions } from "../../../../../../sections/medicinalProduct/message/fieldDefinition-conditions";
import { EntityEnum } from "../../../EntityEnum";
import { MedicinalProductsQueryNode } from "../../MedicinalProductsQueryNode";
import { Art57Section } from "../../../../Art57Section/Art57Section";
import { AutoUploadEntityEnum as AutoUploadEntityEnum } from "../../../../AutoUploadEntityEnum";
import { TreeNodeRoutesOfAdministrationList } from "../../../Art57Node/ListEntity/TreeNodeRoutesOfAdministrationList";

export class ROAQueryNode extends MedicinalProductsQueryNode {
    constructor(injector: Injector) {
    const queryFields: FormlyFieldConfig[] =  new FieldDefinitionFields(injector).roaFields;
    const createChidTemplateParams = {nodeType: 1};
    const queryConditions: FormlyFieldConfig[] = new FieldDefinitionConditions(injector).roaConditions;
       super(injector, [], 'Routes of Administration', EntityEnum.roa,  queryFields, queryConditions,injector.get(Art57Section).medicinalProduct.roaTreeNode,TreeNodeRoutesOfAdministrationList,AutoUploadEntityEnum.roa, createChidTemplateParams);       
    }
}